import React from "react";
import { Deposit } from "../../../../../types/bookings";
import { StickyNote } from "lucide-react";
import { WebViewPopover } from "../../SubHeader/WebViewPopover";
import { EDSButton } from "../../../../eds/EDSButton";

type SelectedBookingPaymentNoteType = {
  deposit: Deposit;
};

export const SelectedBookingPaymentNote = ({
  deposit
}: SelectedBookingPaymentNoteType) => {
  const note = deposit.notes;

  if (!note) {
    return null;
  }

  return (
    <div className="PaymentNote w-9">
      <WebViewPopover
        side="bottom"
        content={
          <div className="PaymentNote-Container p-[var(--panelPadding)] bg-[var(--footerBackground)] border border-[#757982] rounded-lg">
            <div className="PaymentNote-Header">Notes</div>
            <div className="PaymentNote-Content pt-[var(--panelPadding)]">
              {note}
            </div>
          </div>
        }
      >
        <EDSButton size="icon" variant="outline">
          <StickyNote className="w-4 h-4" />
        </EDSButton>
      </WebViewPopover>
    </div>
  );
};
